module.exports = __webpack_public_path__ + "static/think-and-grow-rich-b2fb0ca723dd89c6f915b7d0ee2c9d99.jpg";